module.exports = __webpack_public_path__ + "static/media/borboleta.9f51eb05.webp";